var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialMediaTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  viewBox: "0 0 17 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.12 6.723c-1.405.031-2.716-.406-3.84-1.218v5.589c0 2.123-1.312 3.996-3.31 4.745a5.035 5.035 0 0 1-5.588-1.405 5.11 5.11 0 0 1-.655-5.775c.999-1.842 3.06-2.873 5.182-2.592v2.81a2.36 2.36 0 0 0-2.622.843c-.562.843-.562 1.936.03 2.747a2.33 2.33 0 0 0 2.592.843 2.34 2.34 0 0 0 1.623-2.216V.167h2.748c0 .25 0 .468.062.718a3.7 3.7 0 0 0 1.686 2.498 3.75 3.75 0 0 0 2.092.624z"
}))));
export default SvgSocialMediaTiktok;